import { InboxIcon } from "@heroicons/react/outline";
import React from "react";
import { useTranslation } from "react-i18next";
import { classNames } from "../../Utils";

export const EmptyList = ({
  className = "",
  title = "No Data",
  message = "",
  icon: Icon = InboxIcon,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={classNames(
        className,
        "flex flex-col justify-center text-center text-sm"
      )}
    >
      <Icon className="mx-auto h-12 w-12 text-gray-400" />
      <h3 className="mt-2 font-medium text-slate-900">{t(title)}</h3>
      {message && <p className="text-gray-500">{t(message)}</p>}
    </div>
  );
};
